import ICustomForm from "../../ICustomForm";
import Text from "../Text";
import ICustomFormSettings from "../../ICustomFormSettings";
import SpeechToText from "../../shared/components/SpeechToText/SpeechToText";
import m from "mithril";
import {TextboxItem} from "../../../model/items/textbox";
import {TextareaItem} from "../../../model/items/textarea";
import TextareaCell from "../../shared/components/FormCell/TextareaCell";

export default class TextSpeechToText extends Text implements ICustomForm
{
    constructor(settings: ICustomFormSettings) {
        super(settings);

        let logItem;
        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof TextboxItem) {
                    logItem = cellItem;
                } else if (cellItem instanceof TextareaItem) {
                    this.textareaCell = new TextareaCell(cellItem, true);
                }
            }
        }

        if (!SpeechToText.isSpeechRecognitionSupported()) {
            logItem?.setVariable('Speech recognition not supported.');
        }
        if (this.textareaCell.speechToText && logItem) {
            this.textareaCell.speechToText.setLogItem(logItem);
        }

    }

    public viewTextPart() {
        return m('form', {}, [
            m(this.textareaCell),
        ]);
    }

    public oninit() {
        if (SpeechToText.isSpeechRecognitionSupported()) {
            const originalHint = this.settings.form.hint || this.settings.app.header.hint || '';
            this.settings.app.header.hint = originalHint + (originalHint ? '<br>' : '') + this.settings.form.questionary.messages.get('clickToMicToDict');
        }
    }

    public onremove() {
        this.settings.app.header.hint = null;
    }
}